import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import client from "../lib/api";
import { useSeo } from "../lib/useSeo";
import Layout, { Spinner } from "../components/Layout";
import { NewsCard } from "../components/NewsCard";

export default function Author() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); window.scrollTo(0, 0); client.get(`/authors/${slug}`).then((r) => setData(r.data)).catch(() => setData({ error: true })); }, [slug]);
  useSeo(data?.author ? { title: data.author.name, description: data.author.bio } : {});

  if (!data) return <Layout><Spinner /></Layout>;
  if (data.error) return <Layout><div className="max-w-3xl mx-auto px-4 py-24 text-center font-head text-2xl font-bold">Author not found</div></Layout>;
  const a = data.author;

  return (
    <Layout>
      <div className="bg-r24-black text-white">
        <div className="max-w-7xl mx-auto px-4 py-10 flex items-center gap-5">
          <img src={a.photo || "/brand/logo-512.png"} alt={a.name} className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover ring-2 ring-r24-red" />
          <div>
            <span className="kicker text-xs">{a.role}</span>
            <h1 className="font-head font-bold text-3xl md:text-4xl" data-testid="author-name">{a.name}</h1>
            <p className="text-gray-400 text-sm mt-2 max-w-2xl">{a.bio}</p>
          </div>
        </div>
      </div>
      <section className="max-w-7xl mx-auto px-4 py-10">
        <h2 className="font-head font-bold text-2xl uc mb-6 border-b-2 border-black pb-2">Latest Stories</h2>
        {data.articles?.length === 0 ? <p className="text-gray-500 py-10 text-center">No stories yet.</p> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8" data-testid="author-articles">
            {(data.articles || []).map((x) => <NewsCard key={x.slug} a={x} />)}
          </div>
        )}
      </section>
    </Layout>
  );
}
